export const PEDIDOSLC_OBTENER_PEDIDOS_REQUEST = 'PEDIDOSLC_OBTENER_PEDIDOS_REQUEST';
export const PEDIDOSLC_OBTENER_PEDIDOS_SUCCESS = 'PEDIDOSLC_OBTENER_PEDIDOS_SUCCESS';
export const PEDIDOSLC_OBTENER_PEDIDOS_FAILURE = 'PEDIDOSLC_OBTENER_PEDIDOS_FAILURE';

export const PEDIDOSLC_REALIZAR_PEDIDO_REQUEST = 'PEDIDOSLC_REALIZAR_PEDIDO_REQUEST';
export const PEDIDOSLC_REALIZAR_PEDIDO_SUCCESS = 'PEDIDOSLC_REALIZAR_PEDIDO_SUCCESS';
export const PEDIDOSLC_REALIZAR_PEDIDO_FAILURE = 'PEDIDOSLC_REALIZAR_PEDIDO_FAILURE';
